/* eslint-disable no-script-url */

import React, { useEffect } from "react";
import { getalljobs } from "../../features/Job/jobSlice";
import { useAppDispatch, useAppSelector } from "../../useStore";
import { BsFillBriefcaseFill } from "react-icons/bs";
import { MdScreenShare } from "react-icons/md";
import { FaHireAHelper, FaPeopleArrows } from "react-icons/fa";
import { HiFolderRemove } from "react-icons/hi";
import { applicantDashboardData } from "../../features/Applicant/applicantSlice";
import TopNavigation from "../../layouts/top-navigation/TopNavigation";
import { PiDotsSixVerticalBold } from "react-icons/pi";
import { HiOutlineChevronRight } from "react-icons/hi";
import { useNavigate } from "react-router-dom";
import DoughnutChat from "../../components/Chart/DoughnutChat";
import LineChart from "../../components/Chart/LineChart";
import BarChart from "../../components/Chart/BarChart";
import BottomNavigation from "../../layouts/bottom-navigation/BottomNavigation";


interface Props {
  setActive: string;
}

const Insights: React.FC<Props> = () => {
  const Quote = require('inspirational-quotes');
  // @ts-ignore
  const userInfo = JSON.parse(localStorage.getItem("user_ats"));
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const {
    applicantDashboardDatadata: data
  } = useAppSelector((state: { applicant: any }) => state.applicant);



  // Filter data for different application statuses
  const screening = data?.data?.screenedApplications;
  const applicant = data?.data?.pendingApplications;// Objects with application status "APPLIED"
  const offered = data?.data?.offeredApplications; // Objects with application status "OFFERED"
  const hired = data?.data?.hiredApplications; // Objects with application status "HIRED"
  const dropout = data?.data?.droppedApplications; // Objects with application status "DROPOUT" 
  const evaluation = data?.data?.evaluatedApplications; // Objects with application status "EVALUATION"
  const interview = data?.data?.pendingInterviews;
  const interviewHistory = data?.data?.completedInterviews;



  useEffect(() => {
    dispatch(getalljobs());
    dispatch(applicantDashboardData());
  }, [dispatch]);





  return (
    <div id="screen-wrappers">
      <TopNavigation />
      <BottomNavigation />
      <main>
        <div className='dashboard-container-card mb-2'>
          <div className='dashboard-first-card mb-2'>
            <div>
              <h5 className='dashboard-first-card-h'>Hi {userInfo?.user?.firstName} </h5>
              <p className='dashboard-first-card-p'>{Quote?.getQuote()?.text}<span className="main-min-text2-span"> - {Quote?.getQuote()?.author}</span>.</p>
            </div>
            <div className='dashboard-first-card-icon' onClick={() => navigate("/applicants")}>Applicants <HiOutlineChevronRight /></div>
          </div>
          <div className='dashboard-second-card'>
            <div className='dashboard-radius-icon'>
              <div className="dashboard-second-card-circle">
                <div className="inner-content">
                  <BsFillBriefcaseFill size={23} color='#005b90' />
                </div>
              </div>
              <div>
                <p className='task-text'>Applicants</p>
                <h3>{applicant}</h3>
              </div>
            </div>
            <div className='dashboard-radius-icon'>
              <div className="dashboard-second-card-circle">
                <div className="inner-content">
                  <MdScreenShare size={25} color='#005b90' />
                </div>
              </div>
              <div>
                <p className='task-text'>Screened</p>
                <h3>{screening}</h3>
              </div>
            </div>
            <div className='dashboard-radius-icon'>
              <div className="dashboard-second-card-circle">
                <div className="inner-content">
                  <FaPeopleArrows size={25} color='#005b90' />
                </div>
              </div>
              <div>
                <p className='task-text'>Evaluated</p>
                <h3>{evaluation}</h3>
              </div>
            </div>
            <div className='dashboard-radius-icon'>
              <div className="dashboard-second-card-circle">
                <div className="inner-content">
                  <FaHireAHelper size={25} color='#005b90' />
                </div>
              </div>
              <div>
                <p className='task-text'>Interview</p>
                <h3>{!interview ? 0 : interview}</h3>
              </div>
            </div>
            <div className='dashboard-radius-icon'>
              <div className="dashboard-second-card-circle">
                <div className="inner-content">
                  <HiFolderRemove size={25} color='#005b90' />
                </div>
              </div>
              <div>
                <p className='task-text'>Dropout</p>
                <h3>{!dropout ? 0 : dropout}</h3>
              </div>
            </div>
          </div>
        </div>
        <div className='dashboard-center-item-container'>
          <div className='dashboard-center-item'>
            <div className='dashboard-first-card2 mb-2'>
              <div>
                <h5 className='dashboard-first-card-h'>Total Performance</h5>
              </div>
              <div className='dashboard-first-card-second-icon'>	<PiDotsSixVerticalBold size={20} /></div>
            </div>
            <LineChart applicant={applicant} screening={screening} evaluation={evaluation} interview={interview} interviewHistory={interviewHistory} offered={offered} hired={hired} dropout={dropout} />
          </div>
          <div className='dashboard-center-item'>
            <div className='dashboard-first-card2 mb-2'>
              <div>
                <h5 className='dashboard-first-card-h'>Performance</h5>
              </div>
              <div className='dashboard-first-card-second-icon'>	<PiDotsSixVerticalBold size={20} /></div>
            </div>
            <DoughnutChat applicant={applicant} screening={screening} evaluation={evaluation} dropout={dropout} />
            <div className='DoughnutChatIconcon'>
              <div className='DoughnutChatIconconsub'>
                <span className='DoughnutChatIcon1'></span>
                <p>Applicants</p>
              </div>
              <div className='DoughnutChatIconconsub'>
                <span className='DoughnutChatIcon2'></span>
                <p>Screened</p>
              </div>
              <div className='DoughnutChatIconconsub'>
                <span className='DoughnutChatIcon3'></span>
                <p>Evaluated</p>
              </div>
              <div className='DoughnutChatIconconsub'>
                <span className='DoughnutChatIcon4'></span>
                <p>Dropout</p>
              </div>
            </div>
          </div>
        </div>
        {/* My Teams Performance */}
        <div className='dashboard-bottom-item-container'>
          <div className='dashboard-first-card2 mb-2'>
            <div>
              <h5 className='dashboard-first-card-h'>Recruitment Performance</h5>
              <p className='dashboard-first-card-p'> </p>
            </div>
            <div className='dashboard-first-card-second-icon'>	<PiDotsSixVerticalBold size={20} /></div>
          </div>
          <div className='TeamsPerformancechart'>
            <div className='TeamsPerformancechartsub1'>
              <ul className='TeamsPerformanceUL'>
                <li>Development team</li>
              </ul>
            </div>
            <BarChart threeinone={"threeinone"} applicant={applicant} screening={screening} evaluation={evaluation} interview={interview} interviewHistory={interviewHistory} offered={offered} hired={hired} dropout={dropout} />
          </div>
        </div>
      </main>
    </div>
  );
};

export default Insights;
